module.exports = __webpack_public_path__ + "static/placeholder-timeline1-60a38ee609a1f72acef7f00d7b70d947.png";